import React, { Component } from 'react';
import { Doughnut } from 'react-chartjs-2';

class NumberBadge extends Component {
  render() {
    const {
      value,
      ...otherProps
    } = this.props

    const data = {
      datasets: [
        {
          data: [100],
          backgroundColor: ['#1FD1A1'],
          borderWidth: 0
        }
      ]
    };

    const options = {
      cutoutPercentage: 90,
      responsive: true,
      animation: {
        animateRotate: false
      },
      tooltips: {
        enabled: false
      },
      hover: {
        mode: null
      },
      layout: {
        padding: {
          left: 0,
          right: 0,
          top: 0,
          bottom: 10
        }
      }
    };

    const progressText =  {
      beforeDraw: (chart) => {
        const {
          width,
          height,
          ctx
        } = chart.chart;
        ctx.restore();

        ctx.font = `600 ${width / 5}px Open Sans`;
        ctx.textBaseline = 'middle';
        var text = `${this.props.value}`,
          textX = Math.round((width - ctx.measureText(text).width) / 2),
          textY = height / 2;
        ctx.fillStyle = '#1FD1A1';
        ctx.fillText(text, textX, textY);

        ctx.save();
      }
    };

    return <Doughnut data={data} options={options} plugins={[progressText]} {...otherProps} />
  }
}

export default NumberBadge;


// WEBPACK FOOTER //
// ./src/containers/pages/app/partials/number-badge.js